import s from "./style.module.scss";
import clsx from "clsx";
import { useRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

export const Header = ({
  title,
  onBoarding,
  subTitle,
}: {
  title: string;
  subTitle?: string;
  onBoarding?: boolean;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [height, setHeight] = useState(0);
  const titleRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    if (titleRef.current) {
      const height = titleRef.current.offsetHeight;
      setHeight(height);
    }
  }, [title, subTitle]);
  return (
    <div className={clsx(s.header, onBoarding && s.onBoarding)}>
      <h1 className={s.title} ref={titleRef}>
        <p className={s.subTitle}>{subTitle}</p>
        {title}
      </h1>

      <div className={s.fakeTitle} style={{ height }}></div>
      {!onBoarding && (
        <div className={s.epic}>
          <button
            className={clsx(s.button, location.pathname === "/" && s.active)}
            onClick={() => navigate("/")}
          >
            Услуги
          </button>
          <button
            id="profile"
            className={clsx(
              s.button,
              location.pathname === "/profile" && s.active
            )}
            onClick={() => navigate("/profile")}
          >
            Профиль
          </button>
        </div>
      )}
    </div>
  );
};
